import { render, staticRenderFns } from "./CustomerProject.vue?vue&type=template&id=5fe0e0e1"
import script from "./CustomerProject.vue?vue&type=script&lang=ts"
export * from "./CustomerProject.vue?vue&type=script&lang=ts"
import style0 from "./CustomerProject.vue?vue&type=style&index=0&id=5fe0e0e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports